import React, { useEffect, useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { ILanguageComplianceFilter } from '../../model/types/LanguageComplianceFilter.interface'
import { selectLanguageComplianceFilter } from '../../model/languageComplianceSlice'
import { useGetLanguageComplianceHistoryDetailQuery } from '../../../../app/api'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { Square } from '../../../../shared/components/utility/square/Square'
import { BpTable } from '../../../../shared/components/cards/table/BpTable'
import { TTableResponse } from '../../../../shared/types/TableResponse.type'
import { IBpPaginationProps } from '../../../../shared/components/cards/pagination/BpPagination'
import { SorterResult } from 'antd/lib/table/interface'
import { InfringementsCell } from '../../ui/cells/InfringementsCell'
import { ScreenshotCell } from '../../ui/cells/ScreenshotCell'
import { useSorter } from '../../../../shared/lib/hooks/UseSorter'
import clsx from 'clsx'
import styles from './LanguageComplianceTableExpandRow.module.scss'

export const LanguageComplianceTableExpandRow = ({ record }: any) => {
  const filters = useAppSelector<ILanguageComplianceFilter>(selectLanguageComplianceFilter)
  const { project, country, affiliate, dateRange, restrictedWords, hidden } = filters

  const [queryParams, setQueryParams] = useState<any>({
    page: 1,
    'per-page': 5,
  })
  const { data, isLoading, isFetching } = useGetLanguageComplianceHistoryDetailQuery(queryParams, {
    skip: !queryParams.projectId || !queryParams.countryId,
    refetchOnMountOrArgChange: true,
  })

  useEffect(() => {
    setQueryParams({
      ...queryParams,
      date: dateRange,
      projectId: Number(project),
      countryId: country,
      url: record.url,
      affiliate: affiliate,
      wordId: restrictedWords || undefined,
      showHidden: hidden,
    })
  }, [filters])

  const columns: ColumnsType<any> = [
    {
      title: 'Last Check',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 250,
    },
    {
      title: 'Infringements',
      dataIndex: 'infringements_count',
      key: 'infringements_count',
      render: (_: string, rowRecord) => (
        <InfringementsCell {...rowRecord} state={record.state} url={record.url} />
      ),
      sorter: true,
    },
    {
      title: 'Screenshot',
      dataIndex: 'link_screen_url',
      key: 'link_screen_url',
      render: (_: string, record) => <ScreenshotCell {...record} />,
    },
  ]

  const handleTableChange = (
    { current }: IBpPaginationProps,
    sorter?: SorterResult<any> | SorterResult<any>[],
  ) => {
    setQueryParams({
      ...queryParams,
      page: current,
      'per-page': 5,
      sort: useSorter(sorter),
    })
  }

  return (
    <Square className={clsx(styles.root)}>
      <BpTable
        className='transparent-header'
        columns={columns}
        data={data as TTableResponse<any>}
        dataSource={data?.data?.items}
        loading={isLoading || isFetching}
        pagination={{ pageSize: 5 }}
        rowKey={(record) => record.hash}
        scroll={{ x: 0 }}
        sizePagination={'sm'}
        onChange={(pagination, filters, sorter) => handleTableChange(pagination, sorter)}
      />
    </Square>
  )
}
